// Lodash
import _forEach from 'lodash/forEach';
import _curry from 'lodash/curry';
import _reduce from 'lodash/reduce';
import _isEmpty from 'lodash/isEmpty';

// Constants
import CLICKSTREAM_EVENT_TYPES from '@tekion/tekion-base/events/clickStream/constants/clickstream.eventTypes';
import { EMPTY_ARRAY } from '@tekion/tekion-base/app.constants';

// builders
import ClickStreamEvent from '@tekion/tekion-base/events/clickStream/builders/ClickStreamEvent';

// helpers
import { fireClickstreamEvent } from '@tekion/tekion-base/events/clickStream/helpers/clickStream.eventEmitter';
var addDownloadType = _curry(function (options, downloadFormat, downloadType) {
  options.push({
    downloadFormat: downloadFormat,
    downloadType: downloadType
  });
});
var addOption = function addOption(options, downloadOption) {
  var downloadFormat = downloadOption.downloadFormat,
    _downloadOption$downl = downloadOption.downloadTypes,
    downloadTypes = _downloadOption$downl === void 0 ? EMPTY_ARRAY : _downloadOption$downl;
  if (_isEmpty(downloadTypes)) {
    options.push({
      downloadFormat: downloadFormat
    });
  } else {
    _forEach(downloadTypes, addDownloadType(options, downloadFormat));
  }
  return options;
};
export var createDownloadOptions = function createDownloadOptions(downloadOptions) {
  return _reduce(downloadOptions, addOption, []);
};
export var fireDownloadFileClickStreamEvent = function fireDownloadFileClickStreamEvent(_ref) {
  var downloadFormat = _ref.downloadFormat,
    downloadType = _ref.downloadType,
    module = _ref.module;
  var clickStreamEvent = new ClickStreamEvent(CLICKSTREAM_EVENT_TYPES.REPORT_DOWNLOAD).setEventProperties({
    downloadFormat: downloadFormat,
    downloadType: downloadType,
    module: module
  });
  fireClickstreamEvent(clickStreamEvent);
};